import React from 'react'
import '../../App.less'


const SectionTitle = ({ className, title, ...props }) => {
  return (
    <h2 className={className}> {title} </h2>
  )
}


export default SectionTitle